"use strict";

import { toaster, spinner_main_window } from "./utils.js";

// API Client with security features
export class SecureAPIClient {

    #isLoading;

    constructor(el_loading) {
        this.baseURL = window.location.origin;
        this.token = null;
        this.user = null;
        this.timerId = null;
        this.#isLoading = false;
        this.el_loading = el_loading;
        this.#setLoading(false);
    }

    isLoading() {
        return this.#isLoading;
    }

    // Secure fetch wrapper
    async secureRequest(endpoint, options = {}) {

        this.#setLoading(true);

        const BASE_LOCATION = "/api/path/";
        const url = `${this.baseURL}${BASE_LOCATION}${endpoint}`;

        const headers = {
            'Content-Type': 'application/json',
            ...options.headers
        };

        // Add auth token if available
        if (this.token) {
            headers['Authorization'] = `Bearer ${this.token}`;
        }

        try {
            const response = await fetch(url, {
                ...options,
                headers,
                credentials: 'omit', // No cookies
                referrerPolicy: 'strict-origin-when-cross-origin'
            });

            if (!response.ok) {
                console.log(response);
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || `HTTP ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error('API Request failed:', error);
            toaster({ title: "Error", body: error.message, severity: true });
            throw error;
        } finally {
            this.#setLoading(false);
        }
    }

    async login_from_POST() {

        this.#setLoading(true);
        const API_PATH = '/authenticated/login';
        let response = {}

        try {
            response = await fetch(API_PATH, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({})
            });
        } catch (error) { console.info('Error:', error); }

        if (!response.ok) {
            this.#setLoading(false);
            return false; // window.location.replace(API_PATH); // Redirect to the main authentication page
        }

        const data = await response.json();
        const user = await this.parseJwt(data.jwt);

        const token_duration = user.exp - user.iat;  // minutes

        // Refresh periodically
        clearInterval(this.timerId);
        this.timerId = setInterval(() => {
            console.log(`Ticker!`);
            this.refreshToken();
        }, 1000 * token_duration / 4);

        this.token = data.jwt;
        this.user = user;

        //console.log("return token", this.token)
        this.#setLoading(false);
        return this.token;
    }

    async login_from_URI(jwtToken, refresh) {

        if (!jwtToken)
            return console.log('No token to refresh!!')

        jwtToken = jwtToken.trim();
        const API_PATH = refresh ? '/auth/refresh' : '/auth/callback';

        const response = await this.secureRequest(API_PATH, {
            method: 'POST',
            body: JSON.stringify({ jwt: jwtToken })
        });

        const user = await this.parseJwt(response);

        const token_duration = user.exp - user.iat;  // minutes

        // Refresh periodically
        clearInterval(this.timerId);
        this.timerId = setInterval(() => {
            console.log(`Ticker!`);
            this.refreshToken();
        }, 1000 * token_duration / 4);

        this.token = response;
        this.user = user;

        return response;
    }

    async refreshToken() {
        return this.login_from_URI(this.token, true);
    }

    async logout() {
        await this.secureRequest('/auth/logout', {
            method: 'POST'
        });

        this.token = null;
        this.user = null;
    }

    async getUserProfile() {
        return await this.secureRequest('/api/user/profile');
    }

    async submitData(name, value) {
        const sanitizedName = SecurityUtils.sanitizeInput(name);
        const sanitizedValue = SecurityUtils.sanitizeInput(value);

        if (!SecurityUtils.validateInput(sanitizedName) || !SecurityUtils.validateInput(sanitizedValue)) {
            throw new Error('Invalid input data');
        }

        return await this.secureRequest('/api/data', {
            method: 'POST',
            body: JSON.stringify({
                name: sanitizedName,
                value: sanitizedValue
            })
        });
    }

    #setLoading(loading) {
        this.#isLoading = loading;
        //console.log("setLoading = " + loading);
        spinner_main_window(this.el_loading, loading);
    }

    async loadData() {
        return await this.secureRequest('/api/data');
    }
    async parseJwt(token) {
        if (!token) {
            return;
        }
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace("-", "+").replace("_", "/");
        return JSON.parse(window.atob(base64));
    }
}